export interface VenueParent {
  id?: number;
  name?: string | null;
}

export interface VenueWithParent {
  name?: string | null;
  parent?: VenueParent | null;
}

export const formatVenueName = (venue?: VenueWithParent | null): string => {
  if (!venue) return "N/A";
  if (venue.parent?.name) return `${venue.parent.name} — ${venue.name}`;
  return venue.name || "N/A";
};

export const formatVenueLocation = (
  venue?: VenueWithParent | null,
  addressParts?: (string | null | undefined)[],
): string => {
  const name = formatVenueName(venue);
  const address = addressParts
    ?.filter((v): v is string => Boolean(v?.trim()))
    .join(", ");
  return [name, address].filter(Boolean).join(" · ");
};
